/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UsersRouteImport } from './routes/users'
import { Route as TemplatesRouteImport } from './routes/templates'
import { Route as SystemSettingsRouteImport } from './routes/system-settings'
import { Route as SubscriptionRouteImport } from './routes/subscription'
import { Route as SubscribeFilesRouteImport } from './routes/subscribe-files'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as RulesRouteImport } from './routes/rules'
import { Route as RuleProvidersRouteImport } from './routes/rule-providers'
import { Route as ProbeRouteImport } from './routes/probe'
import { Route as NodesRouteImport } from './routes/nodes'
import { Route as LogsRouteImport } from './routes/logs'
import { Route as LoginRouteImport } from './routes/login'
import { Route as GeneratorRouteImport } from './routes/generator'
import { Route as CustomRulesRouteImport } from './routes/custom-rules'
import { Route as ChangePasswordRouteImport } from './routes/change-password'
import { Route as R404RouteImport } from './routes/404'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TemplatesIndexRouteImport } from './routes/templates.index'
import { Route as TemplatesV3IndexRouteImport } from './routes/templates-v3.index'
import { Route as SubscriptionIndexRouteImport } from './routes/subscription.index'
import { Route as SubscribeFilesIndexRouteImport } from './routes/subscribe-files.index'
import { Route as NodesIndexRouteImport } from './routes/nodes.index'
import { Route as CustomRulesIndexRouteImport } from './routes/custom-rules.index'
import { Route as SubscribeFilesCustomRouteImport } from './routes/subscribe-files.custom'

const UsersRoute = UsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => rootRouteImport,
} as any)
const TemplatesRoute = TemplatesRouteImport.update({
  id: '/templates',
  path: '/templates',
  getParentRoute: () => rootRouteImport,
} as any)
const SystemSettingsRoute = SystemSettingsRouteImport.update({
  id: '/system-settings',
  path: '/system-settings',
  getParentRoute: () => rootRouteImport,
} as any)
const SubscriptionRoute = SubscriptionRouteImport.update({
  id: '/subscription',
  path: '/subscription',
  getParentRoute: () => rootRouteImport,
} as any)
const SubscribeFilesRoute = SubscribeFilesRouteImport.update({
  id: '/subscribe-files',
  path: '/subscribe-files',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const RulesRoute = RulesRouteImport.update({
  id: '/rules',
  path: '/rules',
  getParentRoute: () => rootRouteImport,
} as any)
const RuleProvidersRoute = RuleProvidersRouteImport.update({
  id: '/rule-providers',
  path: '/rule-providers',
  getParentRoute: () => rootRouteImport,
} as any)
const ProbeRoute = ProbeRouteImport.update({
  id: '/probe',
  path: '/probe',
  getParentRoute: () => rootRouteImport,
} as any)
const NodesRoute = NodesRouteImport.update({
  id: '/nodes',
  path: '/nodes',
  getParentRoute: () => rootRouteImport,
} as any)
const LogsRoute = LogsRouteImport.update({
  id: '/logs',
  path: '/logs',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const GeneratorRoute = GeneratorRouteImport.update({
  id: '/generator',
  path: '/generator',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomRulesRoute = CustomRulesRouteImport.update({
  id: '/custom-rules',
  path: '/custom-rules',
  getParentRoute: () => rootRouteImport,
} as any)
const ChangePasswordRoute = ChangePasswordRouteImport.update({
  id: '/change-password',
  path: '/change-password',
  getParentRoute: () => rootRouteImport,
} as any)
const R404Route = R404RouteImport.update({
  id: '/404',
  path: '/404',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TemplatesIndexRoute = TemplatesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => TemplatesRoute,
} as any)
const TemplatesV3IndexRoute = TemplatesV3IndexRouteImport.update({
  id: '/templates-v3/',
  path: '/templates-v3/',
  getParentRoute: () => rootRouteImport,
} as any)
const SubscriptionIndexRoute = SubscriptionIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SubscriptionRoute,
} as any)
const SubscribeFilesIndexRoute = SubscribeFilesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SubscribeFilesRoute,
} as any)
const NodesIndexRoute = NodesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => NodesRoute,
} as any)
const CustomRulesIndexRoute = CustomRulesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CustomRulesRoute,
} as any)
const SubscribeFilesCustomRoute = SubscribeFilesCustomRouteImport.update({
  id: '/custom',
  path: '/custom',
  getParentRoute: () => SubscribeFilesRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/404': typeof R404Route
  '/change-password': typeof ChangePasswordRoute
  '/custom-rules': typeof CustomRulesRouteWithChildren
  '/generator': typeof GeneratorRoute
  '/login': typeof LoginRoute
  '/logs': typeof LogsRoute
  '/nodes': typeof NodesRouteWithChildren
  '/probe': typeof ProbeRoute
  '/rule-providers': typeof RuleProvidersRoute
  '/rules': typeof RulesRoute
  '/settings': typeof SettingsRoute
  '/subscribe-files': typeof SubscribeFilesRouteWithChildren
  '/subscription': typeof SubscriptionRouteWithChildren
  '/system-settings': typeof SystemSettingsRoute
  '/templates': typeof TemplatesRouteWithChildren
  '/users': typeof UsersRoute
  '/subscribe-files/custom': typeof SubscribeFilesCustomRoute
  '/custom-rules/': typeof CustomRulesIndexRoute
  '/nodes/': typeof NodesIndexRoute
  '/subscribe-files/': typeof SubscribeFilesIndexRoute
  '/subscription/': typeof SubscriptionIndexRoute
  '/templates-v3': typeof TemplatesV3IndexRoute
  '/templates/': typeof TemplatesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/404': typeof R404Route
  '/change-password': typeof ChangePasswordRoute
  '/generator': typeof GeneratorRoute
  '/login': typeof LoginRoute
  '/logs': typeof LogsRoute
  '/probe': typeof ProbeRoute
  '/rule-providers': typeof RuleProvidersRoute
  '/rules': typeof RulesRoute
  '/settings': typeof SettingsRoute
  '/system-settings': typeof SystemSettingsRoute
  '/users': typeof UsersRoute
  '/subscribe-files/custom': typeof SubscribeFilesCustomRoute
  '/custom-rules': typeof CustomRulesIndexRoute
  '/nodes': typeof NodesIndexRoute
  '/subscribe-files': typeof SubscribeFilesIndexRoute
  '/subscription': typeof SubscriptionIndexRoute
  '/templates-v3': typeof TemplatesV3IndexRoute
  '/templates': typeof TemplatesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/404': typeof R404Route
  '/change-password': typeof ChangePasswordRoute
  '/custom-rules': typeof CustomRulesRouteWithChildren
  '/generator': typeof GeneratorRoute
  '/login': typeof LoginRoute
  '/logs': typeof LogsRoute
  '/nodes': typeof NodesRouteWithChildren
  '/probe': typeof ProbeRoute
  '/rule-providers': typeof RuleProvidersRoute
  '/rules': typeof RulesRoute
  '/settings': typeof SettingsRoute
  '/subscribe-files': typeof SubscribeFilesRouteWithChildren
  '/subscription': typeof SubscriptionRouteWithChildren
  '/system-settings': typeof SystemSettingsRoute
  '/templates': typeof TemplatesRouteWithChildren
  '/users': typeof UsersRoute
  '/subscribe-files/custom': typeof SubscribeFilesCustomRoute
  '/custom-rules/': typeof CustomRulesIndexRoute
  '/nodes/': typeof NodesIndexRoute
  '/subscribe-files/': typeof SubscribeFilesIndexRoute
  '/subscription/': typeof SubscriptionIndexRoute
  '/templates-v3/': typeof TemplatesV3IndexRoute
  '/templates/': typeof TemplatesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/404'
    | '/change-password'
    | '/custom-rules'
    | '/generator'
    | '/login'
    | '/logs'
    | '/nodes'
    | '/probe'
    | '/rule-providers'
    | '/rules'
    | '/settings'
    | '/subscribe-files'
    | '/subscription'
    | '/system-settings'
    | '/templates'
    | '/users'
    | '/subscribe-files/custom'
    | '/custom-rules/'
    | '/nodes/'
    | '/subscribe-files/'
    | '/subscription/'
    | '/templates-v3'
    | '/templates/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/404'
    | '/change-password'
    | '/generator'
    | '/login'
    | '/logs'
    | '/probe'
    | '/rule-providers'
    | '/rules'
    | '/settings'
    | '/system-settings'
    | '/users'
    | '/subscribe-files/custom'
    | '/custom-rules'
    | '/nodes'
    | '/subscribe-files'
    | '/subscription'
    | '/templates-v3'
    | '/templates'
  id:
    | '__root__'
    | '/'
    | '/404'
    | '/change-password'
    | '/custom-rules'
    | '/generator'
    | '/login'
    | '/logs'
    | '/nodes'
    | '/probe'
    | '/rule-providers'
    | '/rules'
    | '/settings'
    | '/subscribe-files'
    | '/subscription'
    | '/system-settings'
    | '/templates'
    | '/users'
    | '/subscribe-files/custom'
    | '/custom-rules/'
    | '/nodes/'
    | '/subscribe-files/'
    | '/subscription/'
    | '/templates-v3/'
    | '/templates/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  R404Route: typeof R404Route
  ChangePasswordRoute: typeof ChangePasswordRoute
  CustomRulesRoute: typeof CustomRulesRouteWithChildren
  GeneratorRoute: typeof GeneratorRoute
  LoginRoute: typeof LoginRoute
  LogsRoute: typeof LogsRoute
  NodesRoute: typeof NodesRouteWithChildren
  ProbeRoute: typeof ProbeRoute
  RuleProvidersRoute: typeof RuleProvidersRoute
  RulesRoute: typeof RulesRoute
  SettingsRoute: typeof SettingsRoute
  SubscribeFilesRoute: typeof SubscribeFilesRouteWithChildren
  SubscriptionRoute: typeof SubscriptionRouteWithChildren
  SystemSettingsRoute: typeof SystemSettingsRoute
  TemplatesRoute: typeof TemplatesRouteWithChildren
  UsersRoute: typeof UsersRoute
  TemplatesV3IndexRoute: typeof TemplatesV3IndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/users': {
      id: '/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof UsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/templates': {
      id: '/templates'
      path: '/templates'
      fullPath: '/templates'
      preLoaderRoute: typeof TemplatesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system-settings': {
      id: '/system-settings'
      path: '/system-settings'
      fullPath: '/system-settings'
      preLoaderRoute: typeof SystemSettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/subscription': {
      id: '/subscription'
      path: '/subscription'
      fullPath: '/subscription'
      preLoaderRoute: typeof SubscriptionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/subscribe-files': {
      id: '/subscribe-files'
      path: '/subscribe-files'
      fullPath: '/subscribe-files'
      preLoaderRoute: typeof SubscribeFilesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rules': {
      id: '/rules'
      path: '/rules'
      fullPath: '/rules'
      preLoaderRoute: typeof RulesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rule-providers': {
      id: '/rule-providers'
      path: '/rule-providers'
      fullPath: '/rule-providers'
      preLoaderRoute: typeof RuleProvidersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/probe': {
      id: '/probe'
      path: '/probe'
      fullPath: '/probe'
      preLoaderRoute: typeof ProbeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/nodes': {
      id: '/nodes'
      path: '/nodes'
      fullPath: '/nodes'
      preLoaderRoute: typeof NodesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/logs': {
      id: '/logs'
      path: '/logs'
      fullPath: '/logs'
      preLoaderRoute: typeof LogsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/generator': {
      id: '/generator'
      path: '/generator'
      fullPath: '/generator'
      preLoaderRoute: typeof GeneratorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/custom-rules': {
      id: '/custom-rules'
      path: '/custom-rules'
      fullPath: '/custom-rules'
      preLoaderRoute: typeof CustomRulesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/change-password': {
      id: '/change-password'
      path: '/change-password'
      fullPath: '/change-password'
      preLoaderRoute: typeof ChangePasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/404': {
      id: '/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof R404RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/templates/': {
      id: '/templates/'
      path: '/'
      fullPath: '/templates/'
      preLoaderRoute: typeof TemplatesIndexRouteImport
      parentRoute: typeof TemplatesRoute
    }
    '/templates-v3/': {
      id: '/templates-v3/'
      path: '/templates-v3'
      fullPath: '/templates-v3'
      preLoaderRoute: typeof TemplatesV3IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/subscription/': {
      id: '/subscription/'
      path: '/'
      fullPath: '/subscription/'
      preLoaderRoute: typeof SubscriptionIndexRouteImport
      parentRoute: typeof SubscriptionRoute
    }
    '/subscribe-files/': {
      id: '/subscribe-files/'
      path: '/'
      fullPath: '/subscribe-files/'
      preLoaderRoute: typeof SubscribeFilesIndexRouteImport
      parentRoute: typeof SubscribeFilesRoute
    }
    '/nodes/': {
      id: '/nodes/'
      path: '/'
      fullPath: '/nodes/'
      preLoaderRoute: typeof NodesIndexRouteImport
      parentRoute: typeof NodesRoute
    }
    '/custom-rules/': {
      id: '/custom-rules/'
      path: '/'
      fullPath: '/custom-rules/'
      preLoaderRoute: typeof CustomRulesIndexRouteImport
      parentRoute: typeof CustomRulesRoute
    }
    '/subscribe-files/custom': {
      id: '/subscribe-files/custom'
      path: '/custom'
      fullPath: '/subscribe-files/custom'
      preLoaderRoute: typeof SubscribeFilesCustomRouteImport
      parentRoute: typeof SubscribeFilesRoute
    }
  }
}

interface CustomRulesRouteChildren {
  CustomRulesIndexRoute: typeof CustomRulesIndexRoute
}

const CustomRulesRouteChildren: CustomRulesRouteChildren = {
  CustomRulesIndexRoute: CustomRulesIndexRoute,
}

const CustomRulesRouteWithChildren = CustomRulesRoute._addFileChildren(
  CustomRulesRouteChildren,
)

interface NodesRouteChildren {
  NodesIndexRoute: typeof NodesIndexRoute
}

const NodesRouteChildren: NodesRouteChildren = {
  NodesIndexRoute: NodesIndexRoute,
}

const NodesRouteWithChildren = NodesRoute._addFileChildren(NodesRouteChildren)

interface SubscribeFilesRouteChildren {
  SubscribeFilesCustomRoute: typeof SubscribeFilesCustomRoute
  SubscribeFilesIndexRoute: typeof SubscribeFilesIndexRoute
}

const SubscribeFilesRouteChildren: SubscribeFilesRouteChildren = {
  SubscribeFilesCustomRoute: SubscribeFilesCustomRoute,
  SubscribeFilesIndexRoute: SubscribeFilesIndexRoute,
}

const SubscribeFilesRouteWithChildren = SubscribeFilesRoute._addFileChildren(
  SubscribeFilesRouteChildren,
)

interface SubscriptionRouteChildren {
  SubscriptionIndexRoute: typeof SubscriptionIndexRoute
}

const SubscriptionRouteChildren: SubscriptionRouteChildren = {
  SubscriptionIndexRoute: SubscriptionIndexRoute,
}

const SubscriptionRouteWithChildren = SubscriptionRoute._addFileChildren(
  SubscriptionRouteChildren,
)

interface TemplatesRouteChildren {
  TemplatesIndexRoute: typeof TemplatesIndexRoute
}

const TemplatesRouteChildren: TemplatesRouteChildren = {
  TemplatesIndexRoute: TemplatesIndexRoute,
}

const TemplatesRouteWithChildren = TemplatesRoute._addFileChildren(
  TemplatesRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  R404Route: R404Route,
  ChangePasswordRoute: ChangePasswordRoute,
  CustomRulesRoute: CustomRulesRouteWithChildren,
  GeneratorRoute: GeneratorRoute,
  LoginRoute: LoginRoute,
  LogsRoute: LogsRoute,
  NodesRoute: NodesRouteWithChildren,
  ProbeRoute: ProbeRoute,
  RuleProvidersRoute: RuleProvidersRoute,
  RulesRoute: RulesRoute,
  SettingsRoute: SettingsRoute,
  SubscribeFilesRoute: SubscribeFilesRouteWithChildren,
  SubscriptionRoute: SubscriptionRouteWithChildren,
  SystemSettingsRoute: SystemSettingsRoute,
  TemplatesRoute: TemplatesRouteWithChildren,
  UsersRoute: UsersRoute,
  TemplatesV3IndexRoute: TemplatesV3IndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
